module.exports = __webpack_public_path__ + "img/icon-logout.c8477546.svg";